/* globals urls, themeObj, symposium, validate, RSVP */

var $ = jQuery.noConflict();

window.SymposiumAddOn = function(){
	var self = this;
	// Common
	this.RSVP = RSVP;
	this.isEditMode = function(){
		return !!$('.symposium-registration-form input[name="AddOnToUpdate"]').val();
	};
	// https://plainjs.com/javascript/utilities/merge-two-javascript-objects-19/
	this.mergeObjects = function(obj, src) {
		for (var key in src) {
			if (src.hasOwnProperty(key)) obj[key] = src[key];
		}
		return obj;
	};
	this.commonConstraints = {
		FirstName: {presence: true},
		LastName: {presence: true},
		Relationship: {presence: true},
		Gender: {presence: true},
		Age: {
			presence: true,
			numericality: {
				onlyInteger: true
			}
		},
		Email: {presence: true},
		FirstTimeAttendee: {presence: true},
		SelectedDailyActivities: function(value, attributes, attr, options, constraints) {
			return self.isEditMode() ? {} : {
				numericality: {
					greaterThan: 0
				}
			};
		},
	};
	this.productsContainSelector = '#add-on-products-contain';
	this.productAddedClass = 'item-added';
	this.productPriceSelector = '.add-on-product-front-end-price';
	this.productIdSelector = '.add-on-product-front-end-id';
	this.selectedProductPricesSelector = this.productsContainSelector + ' dd.' + this.productAddedClass + ' ' + this.productPriceSelector;
	this.selectedProductIdsSelector = this.productsContainSelector + ' dd.' + this.productAddedClass + ' ' + this.productIdSelector;
	
	// Spouse Add-Ons
	this.spouseFormSelector = '#symp-spouse-program-form';
	this.spouseFormMessagingSelector = this.spouseFormSelector + ' .message-target';
	this.spouseConstraints = this.mergeObjects({
		Phone: {presence: true},
		Address1: {presence: true},
		City: {presence: true},
		Country: {presence: true},
		AddressState: function(value, attributes, attr, options, constraints) {
			return !self.isUsOrCanada(attributes.Country) ? {} : {
				presence: true
			};
		},
		Region: function(value, attributes, attr, options, constraints) {
			return self.isUsOrCanada(attributes.Country) ? {} : {
				presence: true
			};
		},
		Zip: {presence: true},
	}, this.commonConstraints);
	this.spouseAddressFieldNames = ['Address1', 'Address2', 'City', 'Country', 'AddressState', 'Region', 'Zip'];
	this.spouseCustomerAddressFieldNames = ['CustomerAddress1', 'CustomerAddress2', 'CustomerAddressCity', 'CustomerAddressCountry', 'CustomerAddressState', 'CustomerAddressRegion', 'CustomerAddressZip'];
	
	// Youth Add-Ons
	this.youthFormSelector = '#symp-youth-program-form';
	this.youthFormMessagingSelector = this.youthFormSelector + ' .message-target';
	this.youthConstraints = this.mergeObjects({
		photo: function(value, attributes, attr, options, constraints) {
			return self.isEditMode() ? {} : {
				presence: true
			};
		},
		photoType: function(value, attributes, attr, options, constraints) {
			return self.isEditMode() ? {} : {
				presence: true
			};
		},
		ShirtSize: {presence: true},
		EmergencyContactFirstName: {presence: true},
		EmergencyContactLastName: {presence: true},
		EmergencyContactRelationship: {presence: true},
		EmergencyContactEmail: {presence: true},
		EmergencyContactPhone: {presence: true},
	}, this.commonConstraints);
};

// Clear address field values on the front end
SymposiumAddOn.prototype.clearAddressFields = function(){
	$.each( this.spouseAddressFieldNames, function(index, fieldName){
		if( fieldName === 'Country' || fieldName === 'AddressState' ){
			$('select[name="'+fieldName+'"]').val('').trigger('change');
		}
		else{
			$('input[name="'+fieldName+'"]').val('');
		}
	} );
};

// Clear address field values on the front end
SymposiumAddOn.prototype.addressFieldsSameAsCustomer = function(){
	for( var i = 0; i < this.spouseAddressFieldNames.length; i++ ){
		var customerFieldName = this.spouseCustomerAddressFieldNames[i];
		var spouseFieldName = this.spouseAddressFieldNames[i];
		var customerValue = $('input[name="'+customerFieldName+'"]').val();
		if( spouseFieldName === 'Country' || spouseFieldName === 'AddressState' ){
			$('select[name="'+spouseFieldName+'"]').val(customerValue).trigger('change');
		}
		else{
			$('input[name="'+spouseFieldName+'"]').val(customerValue);
		}
	}
};

// Update calculated total for this Add-On
SymposiumAddOn.prototype.calculateTotal = function(){
	var total = 0.00;
	var selectedPrices = $(this.selectedProductPricesSelector);
	selectedPrices.each(function(){
		var price = parseFloat( $(this).val() );
		total += price;
	});
	return total.toFixed(2);
};

// Update calculated total for this Add-On
SymposiumAddOn.prototype.selectedProductIds = function(){
	var ids = [];
	var selectedIds = $(this.selectedProductIdsSelector);
	selectedIds.each(function(){
		var id = parseInt( $(this).val() );
		ids.push(id);
	});
	return ids;
};

// Add this Symposium Add-On registration to the user's cart and redirect them to the appropriate page or display an error message
SymposiumAddOn.prototype.addToCart = function(type, formData){
	var self = this;
	var data = this.buildCartData( type, formData );
	
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: data
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( res.data.redirect );
			}
			reject( res.message || 'An error occurred while adding your registration to the cart' );
		});
	});
};

// Add this Symposium Add-On registration to the user's cart and redirect them to the appropriate page or display an error message
SymposiumAddOn.prototype.buildCartData = function(type, formData){
	var data = {};
	
	var constraints = ( type === 'youth' ? this.youthConstraints : this.spouseConstraints );
	for( var key in constraints ){
		// Exclude photo data, since we can get that from session data
		if (key !== 'photo' && key!== 'photoType') {
			data[key] = formData[key];
		}
	}
	
	// Add non-required fields
	data.DietaryRestrictions = formData.DietaryRestrictions || '';
	data.EmergencyContactNote = formData.EmergencyContactNote || '';
	data.SelectedDailyActivityIds = formData.SelectedDailyActivityIds || [];
	if( type === 'spouse' ){
		data.Address2 = formData.Address2 || '';
	}
	// Add other misc data
	data.action = this.isEditMode() ? 'update_symp_add_on' : 'add_symp_add_on_to_cart';
	data.type = type;
	data.currentCartItem = formData.CurrentCartItem || '';
	data.enrollmentToUpdate = formData.EnrollmentToUpdate || '';
	data.addOnToUpdate = formData.AddOnToUpdate || '';
	
	return data;
};

// Helper function to check if a country name represents the US or Canada
SymposiumAddOn.prototype.isUsOrCanada = function(strCountry){
	var blnRet = false;

	// Assume no value is true, to show the state dropdown when no country is shown
	if(!strCountry){
		return true;
	}

	switch(strCountry){
		case 'Canada':
		case 'Can':
		case 'CAN':
		case 'United States':
		case 'United States of America':
		case 'United States Of America':
		case 'US':
		case 'U.S.':
		case 'USA':
		case 'U.S.A.':
		case '': // Assume no value is true, to show the state dropdown when no country is shown
			blnRet = true;
			break;
	}

	return blnRet;
};

// Initializes the youth photo upload dropzone
SymposiumAddOn.prototype.initYouthPhotoDropzone = function(){
	// Youth photo upload config
	Dropzone.autoDiscover = false;
	this.youthPhotoDropzone = new Dropzone('div#youth-photo-dropzone', {
		url: urls.ajax,
		params: {
			action: 'upload_symposium_youth_photo'
		},
		paramName: 'photo',
		maxFiles: 1,
		maxFilesize: 3, // MB
		dictFileTooBig: 'File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.',
		resizeWidth: 1000,
		resizeMimeType: 'image/jpeg',
		addRemoveLinks: true,
		dictRemoveFile: 'Remove photo',
		dictFallbackMessage: '',
		forceFallback: false
	});

	var isDropzoneSupported = ['HTMLFormElement', 'HTMLDivElement'].indexOf(this.youthPhotoDropzone.constructor.name) === -1;
	this.youthPhotoDropzoneSupported = isDropzoneSupported;
	if (isDropzoneSupported) {
		// Remove additional files after the first is uploaded
		this.youthPhotoDropzone.on('maxfilesexceeded', function(file) {
			$('#dropzone-error-message').text('Only one photo can be uploaded. Additional files have been removed.');
			this.removeFile(file);
		});
		// After a file is successfully uploaded, update hidden fields with photo data and type
		this.youthPhotoDropzone.on('success', function(file, response) {
			$('#youth-photo-data').val('uploaded');
			$('#youth-photo-type').val(response.mimetype);
			$('#dropzone-error-message').text('');
		});
		// After the dropzone is reset, clear out the appropriate fields
		this.youthPhotoDropzone.on('reset', function(file){
			$('#youth-photo-data').val('');
			$('#youth-photo-type').val('');
			$('#dropzone-error-message').text('');
		});
		// Display error messages below dropzone
		this.youthPhotoDropzone.on('error', function(file, error){
			var message = typeof error === 'object' && error.error ? error.error : error;
			$('#dropzone-error-message').text(message);
		})
	}
	else{
		$('.photo-upload-fallback').show();
		$('.dropzone .dz-message').hide();
	}
};

// Initializes the default image to display in the youth photo upload dropzone when editing a registration cart tiem
SymposiumAddOn.prototype.maybeAddDefaultYouthPhotoToDropzone = function(){
	if (this.youthPhotoDropzoneSupported && youthPhotoDefaultData) {
		// Create an accepted mock file
		var mockFile = {
			name: 'Your Photo',
			size: youthPhotoDefaultData.size,
			accepted: true
		};

		// Call the default addedfile event handler
		this.youthPhotoDropzone.emit('addedfile', mockFile);
		this.youthPhotoDropzone.files.push(mockFile);

		// Show the thumbnail of the file
		this.youthPhotoDropzone.emit('thumbnail', mockFile, youthPhotoDefaultData.src);

		// Make sure that there is no progress bar, etc...
		this.youthPhotoDropzone.emit('complete', mockFile);
	}
};

(function($, SymposiumRegistration, SymposiumAddOn) {
	// Calculate the initial total based on the currently selected products, but only if we're on the spouse/guest or youth registration page
	if( $(SymposiumAddOn.spouseFormSelector + ', ' + SymposiumAddOn.youthFormSelector).length ){
		// Refresh the page if the user got here using the back/forward browser button
		SymposiumRegistration.refreshOnBackNavigation();
		
		var initialTotal = SymposiumAddOn.calculateTotal();
		SymposiumRegistration.updateTotal( initialTotal );
	}

	// Initialize youth photo dropzone
	if( !SymposiumAddOn.isEditMode() && $(SymposiumAddOn.youthFormSelector).length ){
		SymposiumAddOn.initYouthPhotoDropzone();
		SymposiumAddOn.maybeAddDefaultYouthPhotoToDropzone();
	}
	
	// Select and deselect Symposium Add-On items, and recalculate the total to display for this registration form
	$('form#symp-spouse-program-form .add-symposium-item').click(function(e){
		e.preventDefault();
		$(this).toggleClass('added').closest('dd').toggleClass('item-added').prev('dt').find('.tab-title a').toggleClass('item-added');
		var newTotal = SymposiumAddOn.calculateTotal();
		SymposiumRegistration.updateTotal( newTotal );
	});
	
	// Set address fields to the customer's shipping address or clear them out when the user clicks on the "Same address as me" checkbox
	$('form#symp-spouse-program-form #same-address').change(function(){
		if( $(this).prop('checked') ){
			SymposiumAddOn.addressFieldsSameAsCustomer();
		}
		else{
			SymposiumAddOn.clearAddressFields();
		}
	});
	
	// Spouse registration form submit handler
	$(SymposiumAddOn.spouseFormSelector).submit(function(e){
		e.preventDefault();
		
		// Clear any previous validation errors
		SymposiumRegistration.clearRegistrationErrors( SymposiumAddOn.spouseFormMessagingSelector );
		SymposiumRegistration.updateLoadingState(true);
		// Collect form values
		var objRegistrationData = validate.collectFormValues(e.target);
		// Add in count of selected products to registration data, to allow validation of required number of selected products
		var selectedActivityIds = SymposiumAddOn.selectedProductIds();
		objRegistrationData.SelectedDailyActivities = selectedActivityIds.length;
		objRegistrationData.SelectedDailyActivityIds = selectedActivityIds;
		// Validate form values against constraints
		var objConstraints = SymposiumAddOn.spouseConstraints;
		var objValidationErrors = SymposiumRegistration.validate(objRegistrationData, objConstraints);
		if( objValidationErrors ){
			SymposiumRegistration.showRegistrationErrors( SymposiumAddOn.spouseFormMessagingSelector, objValidationErrors );
		}
		else{
			SymposiumAddOn.addToCart('spouse', objRegistrationData).then(function(redirect){
				window.location = redirect;
			}).catch(function(error){
				// Display add to cart error message
				SymposiumRegistration.showRegistrationErrors( SymposiumAddOn.spouseFormMessagingSelector, {}, 'Registration Error', error );
			});
		}
	});
	
	// Youth registration form submit handler
	$(SymposiumAddOn.youthFormSelector).submit(function(e){
		e.preventDefault();
		
		// Clear any previous validation errors
		SymposiumRegistration.clearRegistrationErrors( SymposiumAddOn.youthFormMessagingSelector );
		SymposiumRegistration.updateLoadingState(true);
		// Collect form values
		var objRegistrationData = validate.collectFormValues(e.target);
		// Add in count of selected products to registration data, to allow validation of required number of selected products
		var selectedActivityIds = SymposiumAddOn.selectedProductIds();
		objRegistrationData.SelectedDailyActivities = selectedActivityIds.length;
		objRegistrationData.SelectedDailyActivityIds = selectedActivityIds;
		// Validate form values against constraints
		var objConstraints = SymposiumAddOn.youthConstraints;
		var objValidationErrors = SymposiumRegistration.validate(objRegistrationData, objConstraints);
		if( objValidationErrors ){
			SymposiumRegistration.showRegistrationErrors( SymposiumAddOn.youthFormMessagingSelector, objValidationErrors );
		}
		else{
			SymposiumAddOn.addToCart('youth', objRegistrationData).then(function(redirect){
				window.location = redirect;
			}).catch(function(error){
				// Display add to cart error message
				SymposiumRegistration.showRegistrationErrors( SymposiumAddOn.youthFormMessagingSelector, {}, 'Registration Error', error );
			});
		}
	});
})(jQuery, new SymposiumRegistration(), new SymposiumAddOn());